<template>
  <div class="recommend-items-base other-items">
    <h4><img src="/static/img/yearluck/y2020/titlelabel/other_fortunes.svg"></h4>
    <template v-for="(item, index) in itemListMod">
      <article-card
        :key="index"
        :tgt-item="item"
        :tgt-birthday="tgtBirthday"
        @detailBtnClick="onDetailBtnClick(index)"
      ></article-card>
    </template>
    <div class="back-to-top"><a :href="backUrl">運勢一覧に戻る</a></div>
  </div>
</template>

<script>
import ArticleCard from "@/utvStore/components/YearLuck/y2020/partials/articleCard";

export default {
  name: "otherItems",
  components: { ArticleCard },
  data() {
    return {
      targetIdx: -1,
      targetDetailData: {}
    }
  },
  props: {
    itemList: {
      type: Array,
      default() {
        return []
      }
    },
    backUrl: {
      type: String,
      default() {
        return ''
      }
    },
    tgtBirthday: {
      type: String,
      default() {
        return ''
      }
    }
  },
  computed: {
    itemListMod() {
      return this.itemList
    }
  },
  methods: {
    onDetailBtnClick(idx){
      this.targetIdx = idx
      this.targetDetailData = this.itemList[idx]
      this.$emit('onDetailBtnClick', idx)
    }
  }
}</script>

<style scoped lang="scss">
@import "../../../../../../sass/variables/index";
.recommend-items-base {
  background: #fbfaf7;
  h4 {
    img {
      display: block;
      margin: 0 auto;
    }
  }
  .back-to-top {
    width: 100%;
    a {
      display: block;
      width: 100%;
      padding: 12px 8px;
      position: relative;
      background: $brown-10;
      text-align: center;
      color: white;
      font-weight: bold;
      font-size: 14px;
      text-decoration: none;
      cursor: pointer;
      &:after {
        content: '';
        width: 10px;
        height: 18px;
        position: absolute;
        top: 0;
        bottom: 0;
        right: 16px;
        margin: auto;
        background: url('/static/img/yearluck/y2020/next_white.svg') no-repeat center center;
        background-size: auto 18px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/YearLuck/y2020/partials/otherItems.vue